<div class="content-container">
  <div class="container">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Lifting height from the floor to bin</mat-label>
      <input matInput type="number" autoComplete="off" (keypress)="integerOnly($event)" [ngModel]="podest?.height"
        (ngModelChange)="podest.height = $event">
    </mat-form-field>
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Inner height of compartment</mat-label>
      <input matInput type="number" autoComplete="off" (keypress)="integerOnly($event)"
        [ngModel]="baseDimension?.box?.height" (ngModelChange)="baseDimension.box.height = $event">
    </mat-form-field>
  </div>
</div>